import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
const appElement = document.getElementById('maincontent');
Modal.setAppElement(appElement ? appElement : document.getElementsByTagName('body')[0]);
const ModalDialog = (props) => {
    const { t } = useTranslation();
    const closeButton = () => {
        return (React.createElement("button", { type: "button", "aria-label": t('button.close'), className: classNames('modal__close', { 'modal__close--inverted-sm': props.closeInvertedSm }, props.closeButtonClasses), onClick: (e) => {
                e.stopPropagation();
                props === null || props === void 0 ? void 0 : props.onRequestClose(e);
            } }));
    };
    return (React.createElement(Modal, Object.assign({ closeTimeoutMS: 600 }, props, { shouldFocusAfterRender: true, shouldReturnFocusAfterClose: true, overlayClassName: classNames('overlay-modal', props.overlayClassName), className: classNames(props.drawers ? 'drawers' : 'modal', props.noPadding && 'modal--no-padding', props.className) }),
        !props.buttonInHeader && closeButton(),
        !props.hideHeader && (React.createElement("div", { className: "modal__header" },
            props.buttonInHeader && closeButton(),
            React.createElement("h2", { id: "dialog1_label", className: "dialog__title" }, props.contentLabel),
            props.subjsx && props.subjsx(),
            props.subtitle && React.createElement("p", { className: "dialog__description" }, props.subtitle))),
        props.hasDivisor && React.createElement("hr", { className: "modal__divisor" }),
        React.createElement("div", { className: "modal__body" }, props.children)));
};
export default ModalDialog;
